<template>
	<div class="mt-minus-16 mb-24">
		<button
			v-if="show_form === false"
			class="button button--small"
			type="button"
			@click="show_form = !show_form"
		>
			Create a new {{ formTitle.toLowerCase() }}
		</button>
		<form
			v-else
			@submit.prevent="clientUserForm"
		>
			<div
				class="form__set form__set--wrap"
			>
				<InputComponent
					:value="localised_form_fields.full_name"
					type="text"
					input-id="full-name"
					name="full-name"
					label="Full Name"
					:required="true"
					:errors="localised_form_errors.full_name || null"
					@update:value="new_value => localised_form_fields.full_name = new_value"
				/>
				<InputComponent
					:value="localised_form_fields.email"
					type="email"
					input-id="email"
					name="email"
					label="Email address"
					:required="true"
					:errors="localised_form_errors.email || null"
					@update:value="new_value => localised_form_fields.email = new_value"
				/>
				<InputComponent
					:value="localised_form_fields.role"
					type="text"
					input-id="role"
					name="role"
					label="Role"
					sub-label="Optional"
					:required="false"
					:errors="localised_form_errors.role || null"
					@update:value="new_value => localised_form_fields.role = new_value"
				/>
				<p
					v-if="client_user_form_errors"
					class="form__error pre-wrap"
				>
					{{ client_user_form_errors }}
				</p>
				<div class="flex flex--wrap flex--gap-large flex--align-center">
					<button
						class="button button--fill button--small"
						type="submit"
					>
						Add {{ formTitle.toLowerCase() }}
					</button>
					<button
						class="a a--no-underline a--small"
						type="button"
						@click="show_form = !show_form"
					>
						Cancel
					</button>
				</div>
			</div>
		</form>
	</div>
</template>

<script setup>
import { useNewProjectStore } from '../../stores/new-project.js';
import { ref, defineProps, defineEmits } from 'vue';
import { storeToRefs } from 'pinia';
import InputComponent from '../InputComponent';

const new_project_store = useNewProjectStore();
const { createClientUser } = new_project_store;
const {
	client_user_form_fields,
	client_user_form_errors
} = storeToRefs( new_project_store );

const localised_form_errors = ref( [] );
const localised_form_fields = ref( {
	full_name: '',
	email: '',
	role: ''
} );

const emit = defineEmits( ['refresh:client-users'] );

const props = defineProps( {
	fieldHandle: {
		required: true,
		type: String,
		default: null
	},
	formTitle: {
		required: false,
		type: String,
		default: null
	}
} );

const show_form = ref( false );

async function clientUserForm() {
	localised_form_errors.value = [];
	if ( localised_form_fields.value.full_name === '' ) {
		localised_form_errors.value.full_name = ['Please enter the contact\'s full name'];
	}
	if ( localised_form_fields.value.email === '' ) {
		localised_form_errors.value.email = ['Please enter the contact\'s email address'];
	}
	if ( Object.keys( localised_form_errors.value ).length > 0 ) {
		return;
	}
	if ( localised_form_fields.value.full_name !== '' ) {
		client_user_form_fields.value.full_name = localised_form_fields.value.full_name;
	}
	if ( localised_form_fields.value.email !== '' ) {
		client_user_form_fields.value.email = localised_form_fields.value.email;
	}
	if ( localised_form_fields.value.role !== '' ) {
		client_user_form_fields.value.role = localised_form_fields.value.role;
	}
	if ( !client_user_form_errors.value ) {
		await createClientUser();
		emit( 'refresh:client-users', client_user_form_fields.value.full_name, props.fieldHandle );
		closeForm();
	}
}

function closeForm() {
	show_form.value = false;
	localised_form_fields.value.full_name = '';
	localised_form_fields.value.email = '';
	localised_form_fields.value.role = '';
	localised_form_errors.value = [];
	client_user_form_fields.value.full_name = '';
	client_user_form_fields.value.email = '';
	client_user_form_fields.value.role = '';
	client_user_form_errors.value = null;
}

</script>